export default __webpack_public_path__ + "static/media/bg_buy_open.3849b4f0.svg";